import React from "react";
import Select, { Props } from "react-select";
import { selectCustomStyles, selectLabelStyles } from "../../../styles";

interface IReactSelectProps extends Props {
  label: string;
}

export default function ReactSelect({
  label,
  className,
  ...props
}: IReactSelectProps) {
  return (
    <div
      className={`position-relative ${className ? ` ${className}` : ""}`}
      translate="no"
    >
      <Select
        styles={selectCustomStyles}
        {...props}
        components={{
          IndicatorSeparator: () => null,
        }}
        menuPortalTarget={document.body}
      />
      <label
        className={`position-absolute top-0 start-0`}
        style={selectLabelStyles}
      >
        {label}
      </label>
    </div>
  );
}
